import { SvgTypesProps } from "@/shared/types/SvgTypes";


export function IconError({
  fill = 'var(--steel-20)',
  width = 16,
  height = 16,
}: SvgTypesProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.77783 13C10.0915 13 12.7778 10.3137 12.7778 7C12.7778 3.68629 10.0915 1 6.77783 1C3.46412 1 0.777832 3.68629 0.777832 7C0.777832 10.3137 3.46412 13 6.77783 13Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.77783 5L4.77783 9"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.77783 5L8.77783 9"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
